import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import HreflangTags from "@/components/site/HreflangTags";
import CookieConsent from "@/components/site/CookieConsent";

import Home from "@/pages/Home";
import About from "@/pages/About";
import OurTeam from "@/pages/OurTeam";
import OurServices from "@/pages/OurServices";
import ProjectsPartnerships from "@/pages/ProjectsPartnerships";
import OurExhibitions from "@/pages/OurExhibitions";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Imprint from "@/pages/Imprint";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import OurVenues from "@/pages/OurVenues";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <HreflangTags />
          <Navbar />
          <main className="pt-[80px]">
            <Routes>
              {/* English routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<OurTeam />} />
              <Route path="/services" element={<OurServices />} />
              <Route path="/projects" element={<ProjectsPartnerships />} />
              <Route path="/exhibitions" element={<OurExhibitions />} />
              <Route path="/venues" element={<OurVenues />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />

              {/* German routes */}
              <Route path="/de" element={<Home />} />
              <Route path="/de/ueber-uns" element={<About />} />
              <Route path="/de/team" element={<OurTeam />} />
              <Route path="/de/leistungen" element={<OurServices />} />
              <Route path="/de/konzepte" element={<ProjectsPartnerships />} />
              <Route path="/de/ausstellungen" element={<OurExhibitions />} />
              <Route path="/de/locations" element={<OurVenues />} />
              <Route path="/de/faq" element={<FAQ />} />
              <Route path="/de/kontakt" element={<Contact />} />
              <Route path="/de/impressum" element={<Imprint />} />
              <Route path="/de/datenschutz" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
          <Toaster richColors position="bottom-right" />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
